import { View } from 'react-native';
import { Text, useTheme } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import type { WeeklyDrivingReport } from '../api/apiService';

type Attribution = NonNullable<WeeklyDrivingReport['daily_hours'][string]['attributions']>[number];

/** Display identities from recorded work, never from today's relationship. */
export function ReportWorkCompanies({ attributions }: { attributions: Attribution[] }) {
  const { t } = useTranslation();
  const theme = useTheme();
  return <View style={{ gap: 16 }}>
    {attributions.map((identity, index) => <View key={`${identity.company_id ?? 'unknown'}-${index}`} style={{ gap: 8 }}>
      <Text variant="titleMedium" style={{ color: theme.colors.onSurface }}>
        {t('companyName')}: {identity.company_name || t('notProvided')}
      </Text>
      <Text style={{ color: theme.colors.onSurface }}>
        {identity.tax_identifier_kind === 'nif' ? t('nif') : t('nipc')}: {identity.tax_identifier || t('notProvided')}
      </Text>
      <Text style={{ color: theme.colors.onSurface }}>{t('address')}: {identity.address || t('notProvided')}</Text>
      <Text style={{ color: theme.colors.onSurface }}>{t('companyEmail')}: {identity.email || t('notProvided')}</Text>
    </View>)}
  </View>;
}
